var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatDeliver = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19436"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19410"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12122"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m3.838 7.692 2.7 3.121 5.623-5.626",
  "data-name": "Path 6069"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 7591"
})))));
export { SvgChatDeliver as ReactComponent };
export default __webpack_public_path__ + "static/media/chat_deliver.b1ab2cbbfac3a7dc8db0dfae3677e35e.svg";